import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CalibrantLoadModule } from '../calibrant-load/calibrant-load.module';

import { AccountStatusComponent } from './account-status.component';
import {MatTableModule} from "@angular/material/table";
import {MatIconModule} from "@angular/material/icon";
import {MatSortModule} from "@angular/material/sort";
import {MatPaginatorModule} from "@angular/material/paginator";
import {MatTooltipModule} from "@angular/material/tooltip";

@NgModule({
    imports: [
        CommonModule,
        CalibrantLoadModule,
        MatTableModule,
        MatIconModule,
        MatSortModule,
        MatPaginatorModule,
        MatTooltipModule
    ],
  declarations: [
    AccountStatusComponent
  ],
  exports: [
    AccountStatusComponent
  ]
})
export class AccountStatusModule { }
